import { render, staticRenderFns } from "./WardList.vue?vue&type=template&id=dd3aa704&"
import script from "./WardList.vue?vue&type=script&lang=js&"
export * from "./WardList.vue?vue&type=script&lang=js&"
import style0 from "./WardList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports